import type { BillingAccountDto } from '@esportsbudget/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useAuth } from '@/providers/AuthProvider';

import { api } from './api';

/**
 * Единый ключ и запрос для баланса платформы EsportCRM.
 *
 * Namespace `billing` — не `finance`: это деньги пользователя за саму
 * платформу, а не кошельки организации. Ключ вынесен сюда, а не оставлен
 * внутри одного компонента, потому что теперь его читают минимум три места
 * (обязательная модалка региона, виджет в шапке, вкладка настроек) — и все
 * три обязаны видеть один и тот же кэш, а не считать баланс трижды.
 */
export const billingOverviewKey = ['billing', 'overview'] as const;

export function useBillingOverview(): UseQueryResult<BillingAccountDto> {
  const { status } = useAuth();

  return useQuery({
    queryKey: billingOverviewKey,
    queryFn: () => api.get<BillingAccountDto>('/billing', undefined, { skipWorkspace: true }),
    // До завершения auth bootstrap запрос не нужен — токена ещё может не быть.
    enabled: status === 'authenticated',
  });
}
